
import Vue from 'vue';
import PropertyService from '@/services/PropertyService';
import EntityMetaDialog from '@/components/misc/EntityMetaDialog.vue';
import { autoComplete, extractErrorMessage } from '@/utils/Util';
import AlertsListDialog from '@/components/entities/alert/AlertsListDialog.vue';
import NotesListDialog from '@/components/entities/note/NotesListDialog.vue';
import ImageService from '@/services/ImageService';

export default Vue.extend({
  name: 'PropertyInfoDialog',

  components: {
    EntityMetaDialog,
    AlertsListDialog,
    NotesListDialog,
    // Weird import necessary due to circular dependency
    DeviceInfoDialog: () =>
      import('@/components/entities/device/DeviceInfoDialog.vue') as any,
  },
  props: ['property', 'tenant'],
  data: () => ({
    localdialog: false,
    valid: true,
    alertText: '',
    alertVisible: false,
    alertType: 'error',
    loading: false,
    associatedDeviceFilter: '',
    associatedDevices: [] as any[],
    associatedTags: [] as any[],
    associatedAlerts: [] as any[],
    associatedNotes: [] as any[],
    imageData: "" as any,
  }),
  methods: {
    close() {
      this.localdialog = false;
    },
    clear() {
      this.associatedDevices = [];
      this.associatedTags = [];
      this.associatedAlerts = [];
      this.associatedNotes = [];
      this.alertVisible = false;
      this.loading = false;
      this.associatedDeviceFilter = '';
      this.imageData = "";
    },
    dismiss() {
      this.clear();
      this.close();
    },
    hasDeviceDetails(device: any): boolean {
      return !!(device && device.uuid && device.description);
    },
    getAssociatedDevices() {
      this.loading = true;

      PropertyService.getAssociatedDevices(
        this.currentTenant,
        this.property.uuid
      )
        .then((devices: any[]) => {
          if (devices.length > 0) {
            this.associatedDevices = [];
            this.associatedDevices = devices;
          } else {
            this.alertType = 'warning';
            this.alertText = this.$t(
              'property.emptyAssociatedDevice'
            ) as string;
            this.alertVisible = true;
          }
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          console.log(err.response);
          this.alertType = 'error';
          this.alertText =
            this.$t('property.errorAssociatedDevice') +
            ' ' +
            extractErrorMessage(err);
          this.alertVisible = true;
          this.loading = false;
        });
    },
    getAssociatedTags() {
      this.loading = true;

      PropertyService.getAssociatedTags(this.currentTenant, this.property.uuid)
        .then((tags: any[]) => {
          if (tags.length > 0) {
            this.associatedTags = [];
            this.associatedTags = tags;
          }
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          console.log(err.response);
          this.alertType = 'error';
          this.alertText =
            this.$t('property.errorAssociatedDevice') +
            ' ' +
            extractErrorMessage(err);
          this.alertVisible = true;
          this.loading = false;
        });
    },
    openAssociatedDevices() {
      this.$router.push({
        name: 'Devices',
        params: { property: this.property },
      });
    },
    getAssociatedAlerts() {
      this.loading = true;

      PropertyService.getAssociatedAlerts(
        this.currentTenant,
        this.property.uuid
      )
        .then((alerts: any[]) => {
          this.associatedAlerts = alerts;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          console.log(err.response);
          this.alertType = 'error';
          this.alertText =
            this.$t('alert.loadingError') + ' ' + extractErrorMessage(err);
          this.alertVisible = true;
          this.loading = false;
        });
    },
    getAssociatedNotes() {
      PropertyService.getNotes(this.currentTenant, this.property.uuid).then((notes: any[]) => {
        this.associatedNotes = notes;
      }).catch((err: any) => {
        console.log(err, err.response);
      });
    },
    getImage() {
      ImageService.getImage('properties', this.property.uuid).then((imageData) => {
        this.imageData = imageData;
      }).catch((err) => {
        if (err.response && err.response.status === 404) {
          // pass
        } else {
          console.log(err);
          console.log(err.response);
          this.alertType = "error";
          this.alertText = extractErrorMessage(err);
          this.alertVisible = true;
        }
        this.imageData = "";
      });
    },
    autoComplete,
  },
  watch: {
    async localdialog(value: boolean) {
      if (value) {
        this.getAssociatedDevices();
        this.getAssociatedTags();
        this.getAssociatedAlerts();
        this.getAssociatedNotes();
        this.getImage();
      } else {
        this.clear();
      }
    },
  },
  computed: {
    filteredAssociatedDevices(): any[] {
      return this.associatedDevices.filter((value: any) =>
        this.autoComplete(value, this.associatedDeviceFilter)
      );
    },
    currentTenant(): any {
      if (this.tenant) return this.tenant.uuid;

      return this.$root.$store.state.session.selectedTenant.uuid;
    },
  },
});
